var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeticionRecolectando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.09375C22.0625 6.09375 14 13.8874 14 23.4863C14 34.5312 26 52.0343 30.4062 58.0798C30.5891 58.335 30.8289 58.5426 31.1058 58.6858C31.3828 58.829 31.6892 58.9036 32 58.9036C32.3108 58.9036 32.6172 58.829 32.8942 58.6858C33.1711 58.5426 33.4109 58.335 33.5938 58.0798C38 52.0368 50 34.5401 50 23.4863C50 13.8874 41.9375 6.09375 32 6.09375Z",
    fill: "#FFB531",
    stroke: "#E1A02B",
    strokeOpacity: 0.71,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeticionRecolectando);
export default __webpack_public_path__ + "static/media/PeticionRecolectando.dc770a48da83835a959f407fa5e83eb7.svg";
export { ForwardRef as ReactComponent };